import React from 'react';
import styled from 'styled-components';
import Thumbnail from '../components/Thumbnail';
import { ThumbnailContainer } from '../components/Thumbnail';
import { Link } from "react-router-dom";
import TextBlockOben from '../components/TextBlockOben';

const ListContainer = styled.div`
  margin: auto;
  display: inline-block;
  padding-right: 40px
`;

const Home = (props) => (
  <TextBlockOben>
    <h1>Herzlich willkommen!</h1>
    <p>Ich liebe Wolle und deren vielseitige Verwendungsmöglichkeiten.
    </p>
    <p>Ihr findet hier:
    </p>
      <ListContainer>
        <ul>
          <li> <Link to="/galerie/Wolle">Wolle</Link> handgesponnen und selbstgefärbt <br /><br /></li>
          <li> <Link to="/galerie/Sitzkissen">Sitzkissen</Link> handgefilzt<br /><br /></li>
          <li> <Link to="/galerie/strickereien">Strickereien</Link><br /><br /></li>
          <li> <Link to="/galerie/Accessoires">Accessoires</Link> von, für und mit Wolle.<br /><br /><br /></li>
        </ul>
      </ListContainer>
    <p>  Ich wünsche Euch viel Spaß beim Stöbern!
    </p>

    <ThumbnailContainer width={280}>
      <Thumbnail title="Schafwolle, Angorawolle, Babykamel" src={require('../images/TL_Wolle_170314.jpg')} />
      <Thumbnail title="Sitzkissen" src={require('../images/TL_Sitzkissen_170869.jpg')} />
      <Thumbnail title="Strickereien" src={require('../images/TL_werb_200348.jpg')} />
      <Thumbnail title="Accessoires - von, für und mit Wolle" src={require('../images/TL_werb_200338e.jpg')} />
    </ThumbnailContainer>
  </TextBlockOben>
);

export { Home };
